import { useState } from "react";
import { Redirect, Route } from "react-router-dom";
import {
  IonApp,
  IonIcon,
  IonLabel,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonTabs,
} from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import { ellipse, square, triangle } from "ionicons/icons";
import Tab1 from "./pages/Tab1";
import Tab2 from "./pages/Tab2";
import Tab3 from "./pages/Tab3";

/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";

/* Theme variables */
import "./theme/variables.css";

const App = () => {
  const [exp, setExp] = useState(4280);
  const [gold, setGold] = useState(100);
  const [peepConfig, setPeepConfig] = useState({
    accessory: "GlassRoundThick",
    body: "Hoodie",
    face: "Calm",
    hair: "ShortVolumed",
    facialHair: "Full",
  });

  const updatePeepConfig = (key: string, value: string) => {
    if (gold >= 50) {
      let temp = { ...peepConfig };
      temp[key] = value;
      setPeepConfig(temp);
      setGold(gold - 50);
    }
  };

  const addGold = (goldToAdd) => {
    setGold(gold + goldToAdd);
  };

  const addExp = (expToAdd) => {
    setExp(exp + expToAdd);
  };

  return (
    <IonApp>
      <IonReactRouter>
        <IonTabs>
          <IonRouterOutlet>
            <Route exact path="/tab1">
              <Tab1
                gold={gold}
                peepConfig={peepConfig}
                updatePeepConfig={updatePeepConfig}
              />
            </Route>
            <Route exact path="/tab2">
              <Tab2 exp={exp} gold={gold} peepConfig={peepConfig} />
            </Route>
            <Route path="/tab3">
              <Tab3 addGold={addGold} addExp={addExp} />
            </Route>
            <Route exact path="/">
              <Redirect to="/tab2" />
            </Route>
          </IonRouterOutlet>
          <IonTabBar slot="bottom">
            <IonTabButton tab="tab1" href="/tab1">
              <IonIcon icon={triangle} />
              <IonLabel>Shop</IonLabel>
            </IonTabButton>
            <IonTabButton tab="tab2" href="/tab2">
              <IonIcon icon={ellipse} />
              <IonLabel>Home</IonLabel>
            </IonTabButton>
            <IonTabButton tab="tab3" href="/tab3">
              <IonIcon icon={square} />
              <IonLabel>Quests</IonLabel>
            </IonTabButton>
          </IonTabBar>
        </IonTabs>
      </IonReactRouter>
    </IonApp>
  );
};

export default App;
